import React from "react";
import css from "./SheetHeader.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton } from "@mui/material";

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SheetHeader = (props: Props) => {
  return (
    <div className={`${css["comp"]}`}>
      <div></div>
      <div className={`${css["barContainer"]}`}>
        <div className={`${css["bar"]}`}></div>
        <div className={`${css["bar"]}`}></div>
        <div className={`${css["bar"]}`}></div>
      </div>
      <div className={`${css["right"]}`}>
        <Button
          variant="text"
          startIcon={<CloseIcon />}
          sx={{ color: "#333333", fontSize: 14 }}
          onClick={() => {
            props.setOpen(false);
          }}
        >
          閉じる
        </Button>
      </div>
    </div>
  );
};

export default SheetHeader;
